import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43320a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reserved-order-search-page" }
const _hoisted_2 = { class: "search-row" }
const _hoisted_3 = { class: "search-row-title single-ellipsis" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-input-icon-left search-order-input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "result-orders-block2"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "fast-search-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = { class: "fast-search-btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "advanced-search-label" }
const _hoisted_16 = { class: "rows-data" }
const _hoisted_17 = { class: "row-data" }
const _hoisted_18 = { class: "row-data-label" }
const _hoisted_19 = { class: "row-data" }
const _hoisted_20 = { class: "row-data-label" }
const _hoisted_21 = { class: "row-data" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_24 = {
  key: 2,
  style: {"text-align":"center","padding-top":"15px","font-size":"20px","height":"100%"}
}
const _hoisted_25 = { class: "result-orders-block" }
const _hoisted_26 = { class: "page-header" }
const _hoisted_27 = { class: "page-header-title" }
const _hoisted_28 = { class: "filter-tag-items" }
const _hoisted_29 = {
  key: 0,
  class: "filter-tag-item"
}
const _hoisted_30 = { class: "advancedSearch-div" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_32 = { class: "default-grid-columns-template" }
const _hoisted_33 = { class: "column-title" }
const _hoisted_34 = { class: "column-title" }
const _hoisted_35 = { class: "column-title" }
const _hoisted_36 = { class: "column-title" }
const _hoisted_37 = { class: "column-title" }
const _hoisted_38 = {
  class: "list-orders",
  id: "list-orders"
}
const _hoisted_39 = { class: "default-grid-columns-template order-item-data row-with-border h27" }
const _hoisted_40 = { class: "text-ellipsis" }
const _hoisted_41 = { class: "text-ellipsis" }
const _hoisted_42 = { class: "text-ellipsis" }
const _hoisted_43 = { class: "text-ellipsis" }
const _hoisted_44 = { class: "text-ellipsis" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "footer-action" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('cashier.shift.shiftList')), 1),
      (_ctx.searchWas)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.shiftFilter.keywords,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shiftFilter.keywords) = $event)),
                placeholder: _ctx.$t('cashier.label.search'),
                onInput: _cache[1] || (_cache[1] = ($event: any) => {
              _ctx.debounce(() => {
                _ctx.onChangeKeyword();
              })
              })
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.searchWas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!_ctx.shiftFilter.advancedSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_TextInput, {
                    clearable: true,
                    modelValue: _ctx.shiftFilter.keywords,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shiftFilter.keywords) = $event))
                  }, null, 8, ["modelValue"]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "p-ripple",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSearchBy && _ctx.onClickSearchBy(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.search")), 1)
                  ])), [
                    [_directive_ripple]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shiftFilter.advancedSearch = true))
                  }, _toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1),
                  _hoisted_13
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('cashier.shift.startDateTime')), 1),
                    _createVNode(_component_DateInput, {
                      clearable: true,
                      modelValue: _ctx.shiftFilter.startDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shiftFilter.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('cashier.shift.endDateTime')) + ": ", 1),
                    _createVNode(_component_DateInput, {
                      clearable: true,
                      modelValue: _ctx.shiftFilter.endDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shiftFilter.endDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("button", {
                      class: "advanced-search-btn",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch && _ctx.onClickSearch(...args)))
                    }, [
                      _hoisted_23,
                      _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.search")), 1)
                    ])
                  ])
                ])
              ])),
          (_ctx.showNoResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("cashier.label.no-result")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("cashier.header.search-results")), 1),
        _createElementVNode("div", _hoisted_28, [
          (_ctx.shiftFilter.keywords)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.quick-search")) + ": " + _toDisplayString(_ctx.shiftFilter.keywords) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.shiftFilter.keywords = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "showAll",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t("button.showAll")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.advancedSearch && _ctx.advancedSearch(...args)))
          }, [
            _hoisted_31,
            _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('cashier.shift.startDateTime')), 1),
        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('cashier.shift.endDateTime')), 1),
        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('cashier.shift.user')), 1),
        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('cashier.shift.cashierId')), 1),
        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('cashier.shift.balanceDescription')), 1)
      ]),
      _createElementVNode("div", _hoisted_38, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shiftList, (shift, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "order-item"
          }, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(shift.openDateTime), 1),
              _createElementVNode("div", _hoisted_41, _toDisplayString(shift.closeDateTime), 1),
              _createElementVNode("div", _hoisted_42, _toDisplayString(shift.openUserFullName), 1),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.cashierId), 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(shift.balanceDescription), 1),
              _createElementVNode("div", {
                class: "show-details-action text-center",
                onClick: ($event: any) => (_ctx.printShiftReport(shift.shiftId, true))
              }, _toDisplayString(_ctx.$t('cashier.shift.shiftTableOpenReportPrintBtn')), 9, _hoisted_45),
              _hoisted_46,
              (shift.closeDateTime)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "show-details-action text-center",
                    onClick: ($event: any) => (_ctx.printShiftReport(shift.shiftId, false))
                  }, _toDisplayString(_ctx.$t('cashier.shift.shiftTableCloseReportPrintBtn')), 9, _hoisted_47))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.searchWas]
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("button", {
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        type: "button"
      }, [
        _hoisted_49,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.back")), 1)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.loaded]
  ])
}